import React from 'react';
import component from './component';

import YandexMetrika from './YandexMetrika';

export default component('Html', function({webpackAssets, title}) {

  return (
    <html>
      <head>
        <meta charSet='utf-8' />
        <link rel='icon' href={require('../img/favicon.ico')} type='image/x-icon' />
        <link href='//fonts.googleapis.com/css?family=Roboto+Condensed:700,400|Roboto:300,400,500,700&subset=latin,cyrillic' rel='stylesheet' type='text/css' />
        {
          webpackAssets['app.css'] &&
            <link href={webpackAssets['app.css']} rel='stylesheet' type='text/css'/>
        }
        <title>{title}</title>
        <style type='text/css'>{`
        body{background:#f0f0f0}
        @-webkit-keyframes initialIndicator{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}
        @keyframes initialIndicator{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}
        #initial-indicator{box-sizing:border-box;position:fixed;left:50%;top:50%;margin-left:-20px;margin-top:-20px;width:40px;height:40px;border-radius:50%;border:5px solid #ccc;border-top-color:transparent;-webkit-animation:initialIndicator 1s infinite linear;animation:initialIndicator 1s infinite linear}#react-app{display:none}
        `}
        </style>
      </head>
      <body>
        <div id='app'/>
        <div id='initial-indicator'/>
        <script src={webpackAssets['vendor.js']} />
        <script src={webpackAssets['app.js']} />
        <YandexMetrika/>
      </body>
    </html>
  );
});



// WEBPACK FOOTER //
// ./src/components/Html.js